import React, { useState } from "react";
import { StarInput } from "./Stars";
import { FiSend } from "react-icons/fi";
import { apiRequest, errorMessage } from "../../api";
import { Field, FormAlert, SubmitButton } from "../forms/formKit";

// Rate the other side of a completed job (1-5 stars + an optional comment). Calls onDone() when saved.
export default function ReviewForm({ jobId, who, onDone, onCancel }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!rating) return setError("Choose a star rating first.");
    setBusy(true);
    setError("");
    const { ok, data } = await apiRequest(`/core/cowork/jobs/${jobId}/review/`, { method: "POST", auth: true, body: { rating, comment } });
    setBusy(false);
    if (!ok) return setError(errorMessage(data));
    onDone();
  };

  return (
    <form onSubmit={submit} className="mt-4 rounded-xl bg-white/5 border border-navy-border p-4 space-y-3">
      <p className="text-sm font-semibold">How was your experience with {who}?</p>
      <StarInput value={rating} onChange={setRating} />
      <Field
        as="textarea"
        label="Your comment"
        rows={3}
        maxLength={500}
        hint="Optional - a few words about the work and communication"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="What went well?"
      />
      <FormAlert>{error}</FormAlert>
      <div className="flex flex-wrap gap-2">
        <SubmitButton busy={busy} busyLabel="Saving..." icon={FiSend} className="!px-5 !py-2 text-sm">Submit Review</SubmitButton>
        <button type="button" onClick={onCancel} className="px-5 py-2 rounded-full border border-navy-border text-sm text-gray-300 hover:text-white hover:border-accent-light transition-colors">Cancel</button>
      </div>
    </form>
  );
}
